




























































import { Vue, Component, Prop } from 'vue-property-decorator';
import dayjs from '@/plugins/dayjs';

@Component
export default class AttendanceEngagementCard extends Vue {
  @Prop({ default: null }) readonly score!: number | null;

  @Prop({ default: 0 }) readonly totalInteractions!: number;

  @Prop({ default: null }) readonly ultimaAtividade!: Date | null;

  get scoreColor(): string {
    if (this.score === null || this.score === undefined) return 'grey';
    if (this.score >= 70) return 'success';
    if (this.score >= 40) return 'orange';
    return 'error';
  }

  get lastActiveLabel(): string {
    if (!this.ultimaAtividade) return '—';
    const diffHours = dayjs().diff(dayjs(this.ultimaAtividade), 'hour');
    if (diffHours < 1) return this.$t('crm.view.attendance.engagementCard.fewMinutesAgo').toString();
    if (diffHours < 24) return this.$t('crm.view.attendance.engagementCard.hoursAgo', { hours: diffHours }).toString();
    const days = Math.floor(diffHours / 24);
    if (days === 1) return this.$t('crm.view.attendance.engagementCard.oneDayAgo').toString();
    if (days < 30) return this.$t('crm.view.attendance.engagementCard.daysAgo', { days }).toString();
    const months = Math.floor(days / 30);
    if (months === 1) return this.$t('crm.view.attendance.engagementCard.oneMonthAgo').toString();
    return this.$t('crm.view.attendance.engagementCard.monthsAgo', { months }).toString();
  }
}
